(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/parse-value/assets/javascripts/parse-value.js') >= 0) return;  svs.modules.push('/components/lb-utils/parse-value/assets/javascripts/parse-value.js');
"use strict";

let ParseValue;
if (svs.isServer) {
  ParseValue = require('./parse-value-classes.es6');
} else {
  ParseValue = svs.components.lbUtils.parseValue.classes.ParseValue;
}
const parseValue = (value, loggger) => new ParseValue(value, loggger);
if (svs.isServer) {
  module.exports = parseValue;
} else {
  setGlobal('svs.components.lbUtils.parseValue.parseValue', parseValue);
}

 })(window);